export const signForm = {
    visuals: {
        height: '5rem',
        // borderRadius: 'var(--borderRadiusContainerInnerEdge)',
        colorBorder: 'transparent',
        colorBackground: 'var(--colorBackgroundBasic)',
    }
}